import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
class EphemeralObject {
  constructor(content) {
    _defineProperty(this, "type", 'EphemeralObject');
    _defineProperty(this, "content", []);
    _defineProperty(this, "reference", undefined);
    this.content = content;
    this.reference = {};
  }
  toReference() {
    return this.reference;
  }
  toObject() {
    return Object.assign(this.reference, Object.fromEntries(this.content));
  }
}
export default EphemeralObject;